import type { FlexCostType, FlexCode, FlexGlCode } from 'API';
import CodingEntityDropdown from 'app/pages/overview/tabs/transactions/CodingEntityDropdown';

interface FlexCostTypeDropdownProps {
  selectedGlCode?: FlexGlCode | null;
  selectedProject?: FlexCode | null;
  selectedCostType?: FlexCostType | null;
  onValueChange: (option: FlexCostType | null) => void;
  disabled?: boolean;
  disableHeader?: boolean;
  placeholder?: string | null;
}

const FlexCostTypeDropdown = ({
  selectedGlCode,
  selectedProject,
  selectedCostType,
  onValueChange,
  disabled,
  disableHeader = false,
}: FlexCostTypeDropdownProps) => {
  return (
    <CodingEntityDropdown<FlexCostType>
      erpType="flex"
      entityType="costTypes"
      selectedItem={selectedCostType}
      selectedGlCode={selectedGlCode}
      selectedProject={selectedProject}
      onValueChange={onValueChange}
      disabled={disabled}
      disableHeader={disableHeader}
    />
  );
};

export default FlexCostTypeDropdown;
